
export const setupInterceptors = (error: any) => {
    console.log("----> Axios Error:", error);
    if (error.response?.status === 401) {
        // window.location.reload();
    }
    return Promise.reject(error);
};